import api from "services/api";

// Get all employees
export const getEmployees = async () => {
  return api.get("/v1/api/employees/list");
};

// Create a new employee
export const createEmployee = async (employeeData) => {
  return api.post("/v1/api/employees/create", employeeData);
};

// Update an employee
export const updateEmployee = async (employeeId, employeeData) => {
  return api.put(`/v1/api/employees/update/${employeeId}`, employeeData);
};

// Get employee org tree hierarchy
export const getOrgTree = async () => {
  return api.get("/v1/api/employees/org-tree");
};
